import { render, staticRenderFns } from "./AutomationAttributeTiptap.vue?vue&type=template&id=0f46866e&scoped=true"
import script from "./AutomationAttributeTiptap.vue?vue&type=script&lang=js"
export * from "./AutomationAttributeTiptap.vue?vue&type=script&lang=js"
import style0 from "./AutomationAttributeTiptap.vue?vue&type=style&index=0&id=0f46866e&prod&scoped=true&lang=scss"
import style1 from "./AutomationAttributeTiptap.vue?vue&type=style&index=1&id=0f46866e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f46866e",
  null
  
)

export default component.exports